import { defineStore } from 'pinia'
import { snakeCase } from 'lodash'
import repositoryFactory from '@/factories/repository-factory'
import HistoryRepository, { HistoryParams } from '@/repositories/history-repository'
import History from '@/models/History'

const storeKey = 'history'

export const useHistoryStore = defineStore(storeKey, {
  state: () => ({
    history: {} as History,
    cache: {} as { [key: string]: History },
  }),

  actions: {
    async fetch(params: HistoryParams) {
      const repository = (await repositoryFactory.create()).get(storeKey) as HistoryRepository
      params.target = params.target.map(t => {
        // 仕様
        if (['humid1', 'press1'].includes(t)) {
          return t
        }
        return snakeCase(t)
      })

      const result = await repository.get(params)
      this.history = result

      return this.history
    },
  },
})
